import Layout from "../Layout/MainLayout";
import { Typography, Row, Col, Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CircleLine from "../Components/charts/CircleLine";
import StackedAreaPlot from "../Components/charts/StackedAreaPlot";
import AverageConsumptionChart from "../Components/charts/AverageConsumptionChart";
import { AiOutlineFlag } from "react-icons/ai";
import Image from "../Assets/Vector.png";
import React, { useEffect, useState } from "react";
// import Loader from "../Components/Loader";
import DemoTinyLine from "../Components/charts/TinyArea";
import Co2Consumption from "../Components/charts/Co2Consumption";
import MultiView from "../Components/charts/MultiView";
import {
  getActualCo2Emission,
  getCountryCo2Emission,
  getAverageConsumption,
  getCo2Saved,
} from "../redux";

const Co2Emission = () => {
  let text = "This box represents the total conusmed energy by the client";

  const [actual, setActual] = useState([]);
  const [countryCo2, setCountryCo2] = useState(null);
  const [averageConsumption, setAvergaeConsumption] = useState(null);
  const [actualFilter, setActualFilter] = useState("1week");
  const [co2Saved, setco2Saved] = useState(null);
  const [co2SavedFilter, setco2SavedFilter] = useState("1week");

  const onActualFilterChange = async (val) => {
    setActualFilter(val);
    let res = await getActualCo2Emission({ range: val });
    setActual(res);
  };

  const onCo2FilterChange = async (val) => {
    setco2SavedFilter(val);
    let res = await getCo2Saved({ range: val });
    // console.log("onCo2FilterChange ", res);
    setco2Saved(res);
  };

  const getActualData = async () => {
    let res = await getActualCo2Emission({ range: actualFilter });
    setActual(res);
  };

  const getcountryCo2Data = async () => {
    let cco2 = await getCountryCo2Emission();
    setCountryCo2(cco2);
  };

  const getavergaeConsumption = async () => {
    let res = await getAverageConsumption();
    setAvergaeConsumption(res);
  };

  const getco2Saved = async () => {
    let res = await getCo2Saved({ range: co2SavedFilter });
    setco2Saved(res);
  };

  useEffect(() => {
    getActualData();
    getcountryCo2Data();
    getavergaeConsumption();
    getco2Saved();
  }, []);

  return (
    <Layout active="co2emission">
      <div className="live-main energy-main">
        <Row gutter={[30, 30]}>
          <Col xs={24} md={12} xl={8}>
            <div className="live-card white-card">
              <Typography.Title
                className="title main-title"
                level={5}
                style={{
                  fontWeight: "500",
                  marginBottom: "20px",
                  height: "10px",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  Actual Co2 Emission
                  <Tooltip title={text} color={"#37A1DB"}>
                    <InfoCircleOutlined
                      style={{ marginLeft: "5px", marginRight: 10 }}
                    />
                  </Tooltip>
                </span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: 0,
                    marginRight: "5px",
                    height: "10px",
                  }}
                >
                  <div
                    style={{
                      background: "#4F99FD",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      marginRight: "5px",
                    }}
                  />
                  <p
                    style={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      height: "16px",
                      marginBottom: "0px",
                    }}
                  >
                    132 kg
                    {/* {selfData?.total?.toLocaleString("de-DE")}% */}
                  </p>
                </div>
                <Select
                  value={actualFilter}
                  style={{ width: "max-content" }}
                  onChange={onActualFilterChange}
                >
                  <Select.Option value="1week">One Week</Select.Option>
                  <Select.Option value="thismonth">One Month</Select.Option>
                </Select>
              </Typography.Title>

              <div className="chart-wrapper">
                {/* {selfData ? ( */}
                <DemoTinyLine
                  TooltipUnit="Kg/day"
                  unit={"Kg"}
                  Data={actual}
                  color={{
                    hex: "#4F99FD",
                    rgb: [126, 202, 254],
                  }}
                  fields={["date", "value"]}
                />
                {/* ) : ( */}
                {/* <div
                                    className="loading"
                                    style={{ minHeight: "auto", height: "100%" }}
                                >
                                    <Loader />
                                </div> */}
                {/* )} */}
              </div>
            </div>
          </Col>

          <Col xs={24} md={12} xl={8}>
            <div className="live-card white-card">
              <Typography.Title
                className="title main-title"
                level={5}
                style={{
                  fontWeight: "500",
                  marginBottom: "20px",
                  height: "10px",
                }}
              >
                <Row align="middle" style={{ width: "100%" }}>
                  <Col xs={24} md={16} xl={15}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      Country Co2 Emission
                      <Tooltip title={text} color={"#37A1DB"}>
                        <InfoCircleOutlined
                          style={{ marginLeft: "5px", marginRight: 15 }}
                        />
                      </Tooltip>
                    </span>
                  </Col>
                  <Col xs={24} md={8} xl={9}>
                    <div
                      style={{
                        display: "flex",
                        //  gap: "15px"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "15px",
                        }}
                      >
                        <div
                          style={{
                            background: "#F99600",
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            marginRight: 5,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            height: "16px",
                          }}
                        >
                          Renewable
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: 0,
                        }}
                      >
                        <div
                          style={{
                            background: "#DD243B",
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            marginRight: 5,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            height: "16px",
                          }}
                        >
                          Co2
                          {/* {selfData?.total?.toLocaleString("de-DE")}% */}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Typography.Title>
              <div
                className="flex-between"
                style={{ justifyContent: "center" }}
              >
                <div
                  className="chart-wrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  {/* {autonomyData ? ( */}
                  {/* <DemoTinyLine
                                        TooltipUnit="g/Kwh"
                                        unit={`g/Kwh`}
                                        // Data={autonomyData ? autonomyData?.data : []}
                                        fields={["time", "percentage"]}
                                        color={{
                                            hex: "#F99600",
                                            rgb: [249, 150, 0],
                                        }}
                                        noArea
                                    /> */}
                  <StackedAreaPlot
                    lineTwoColor="#F99600"
                    lineOneColor="#DD243B"
                    from="countryCo2"
                    chartData={countryCo2}
                    yFields={["co2_value", "renewable_value"]}
                  />
                  {/* ) : ( */}
                  {/* <div
                                        className="loading"
                                        style={{ minHeight: "auto", height: "100%" }}
                                    >
                                        <Loader />
                                    </div> */}
                  {/* )} */}
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12} xl={8}>
            <div className="live-card white-card">
              <Typography.Title
                className="title main-title"
                level={5}
                style={{
                  fontWeight: "500",
                  marginBottom: "20px",
                  height: "10px",
                }}
              >
                <Row align="middle" style={{ width: "100%" }}>
                  <Col xs={24} md={16} xl={15}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      Average Consumption
                      <Tooltip title={text} color={"#37A1DB"}>
                        <InfoCircleOutlined
                          style={{ marginLeft: "5px", marginRight: 15 }}
                        />
                      </Tooltip>
                    </span>
                  </Col>
                  <Col xs={24} md={8} xl={9}>
                    <div
                      style={{
                        display: "flex",
                        // , gap: "15px"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "15px",
                        }}
                      >
                        <div
                          style={{
                            background: "#4F99FD",
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            marginRight: 5,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            height: "16px",
                          }}
                        >
                          Average
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: 0,
                        }}
                      >
                        <div
                          style={{
                            background: "#DD243B",
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            marginRight: 5,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            height: "16px",
                          }}
                        >
                          Today
                          {/* {selfData?.total?.toLocaleString("de-DE")}% */}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Typography.Title>
              <div
                className="flex-between"
                style={{ justifyContent: "center" }}
              >
                <div
                  className="chart-wrapper"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {/* {autonomyData ? ( */}
                  {/* <div style={{ width: "95%" }}> */}
                  <div style={{ width: "100%" }}>
                    <AverageConsumptionChart
                      lineTwoColor="#DD243B"
                      lineOneColor="#4F99FD"
                      chartData={averageConsumption}
                      yFields={["average_value", "today_value"]}
                    />
                  </div>
                  {/* <p
                    style={{
                      transform: "rotate(-90deg)",
                      marginBottom: "13px",
                      // marginLeft:"5px",
                      fontSize: "10px",
                      color: "#000000",
                      fontWeight: "bold",
                    }}
                  >
                    kg/h
                  </p> */}
                </div>
              </div>
            </div>
          </Col>
          <Col xs={24}>
            <div className="white-card live-big-card">
              <Typography.Title
                className="title main-title"
                level={4}
                style={{ fontWeight: "600", marginBottom: "30px" }}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  Co2 Consumption
                  <Tooltip title={text} placement="right" color={"#37A1DB"}>
                    <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                  </Tooltip>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    <div
                      style={{
                        background: "#DD243B",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        height: "16px",
                      }}
                    >
                      2022
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    <div
                      style={{
                        background: "#4F99FD",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        height: "16px",
                      }}
                    >
                      2023
                      {/* {selfData?.total?.toLocaleString("de-DE")}% */}
                    </span>
                  </div>
                </span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <div
                                        style={{
                                            background: "#DD243B",
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            marginRight: 2,
                                        }}
                                    /> */}
                    <img
                      src={Image}
                      style={{
                        width: "14px",
                        height: "14px",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        height: "16px",
                      }}
                    >
                      Goal:- 25%
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <div
                                        style={{
                                            background: "#4F99FD",
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            marginRight: 2,
                                        }}
                                    /> */}
                    <AiOutlineFlag
                      style={{
                        fontSize: "14px",
                        color: "#4F99FD",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        height: "16px",
                      }}
                    >
                      YTD:- 15%
                      {/* {selfData?.total?.toLocaleString("de-DE")}% */}
                    </span>
                  </div>

                  <Select
                    defaultValue={"lastweek"}
                    style={{ width: "max-content" }}
                  >
                    <Select.Option value="thisweek">This Week</Select.Option>
                    <Select.Option value="thismonth">This Month</Select.Option>
                    <Select.Option value="thisyear">This Year</Select.Option>
                    <Select.Option value="lastweek">Last Week</Select.Option>
                    <Select.Option value="lastmonth">Last Month</Select.Option>
                    <Select.Option value="lastyear">Last Year</Select.Option>
                  </Select>
                </div>
              </Typography.Title>
              <div
                style={{
                  width: "100%",
                }}
              >
                {/* {energyGraph ? ( */}
                {/* <ColumnLineDualAxis
                                        leftUnit="kg"
                                        rightUnit="kWh"
                                        isStack
                                        Data={
                                            energyGraph
                                                ? energyGraph
                                                : {
                                                    lineData: [],
                                                    barData: [],
                                                }
                                        }
                                    /> */}
                {/* ) : ( */}
                <Co2Consumption leftUnit="kg" rightUnit="kWh" />
                {/* <div
                                        className="loading"
                                        style={{ minHeight: "auto", height: "100%" }}
                                    >
                                        <Loader />
                                    </div> */}
                {/* )} */}
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="white-card tiny-column-card">
              <Typography.Title
                className="title main-title"
                level={5}
                style={{ fontWeight: "500", marginBottom: "10px" }}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  Co2 Consumption
                  <Tooltip title={text} color={"#37A1DB"}>
                    <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                  </Tooltip>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    <div
                      style={{
                        background: "#2EC276",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        // height: "16px",
                      }}
                    >
                      EnExpert
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    <div
                      style={{
                        background: "#DD243B",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        // height: "16px",
                      }}
                    >
                      Market
                      {/* {selfData?.total?.toLocaleString("de-DE")}% */}
                    </span>
                  </div>
                </span>

                {/* <div
                                    className="flex-between"
                                    style={{ alignItems: "flex-start", margin: "10px" }}
                                >
                                    <Typography.Text
                                        style={{
                                            fontWeight: "600",
                                            color: "#121212",
                                            // color: "var(--green)",
                                            fontSize: "1rem",
                                            display: "flex",
                                            alignItems: "center",
                                            margin: "0",
                                            height: "1.2rem",
                                        }}
                                    >
                                        <img src={savingIcon} style={{ marginRight: 5 }} />
                                        {savingData?.total?.toLocaleString("de-DE")} €
                                    </Typography.Text>
                                </div> */}

                <Select
                  defaultValue={"lastweek"}
                  style={{ width: "max-content" }}
                >
                  <Select.Option value="thisweek">This Week</Select.Option>
                  <Select.Option value="thismonth">This Month</Select.Option>
                  <Select.Option value="thisyear">This Year</Select.Option>
                  <Select.Option value="lastweek">Last Week</Select.Option>
                  <Select.Option value="lastmonth">Last Month</Select.Option>
                  <Select.Option value="lastyear">Last Year</Select.Option>
                </Select>
              </Typography.Title>
              <div className="tinycolumn">
                <MultiView />
                {/* {savingData ? ( */}
                {/* <CircleLine
                  TooltipUnit={"g/kwh"}
                  unit={`g/kwh`}
                  Data={[]}
                  color={"#DD243B"}
                  
                /> */}
                {/* ) : ( */}
                {/* <div
                                        className="loading"
                                        style={{ minHeight: "auto", height: "100%" }}
                                    >
                                        <Loader />
                                    </div> */}
                {/* )} */}
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="white-card tiny-column-card">
              <Typography.Title
                className="title main-title"
                level={5}
                style={{ fontWeight: "500", marginBottom: "10px" }}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  Co2 Saved
                  <Tooltip title={text} color={"#37A1DB"}>
                    <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                  </Tooltip>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      marginLeft: "10px",
                    }}
                  >
                    <div
                      style={{
                        background: "#DD243B",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        height: "16px",
                      }}
                    >
                      Co2
                    </span>
                  </div>
                </span>

                <Select
                  defaultValue={co2SavedFilter}
                  style={{ width: "max-content" }}
                  onChange={onCo2FilterChange}
                >
                  <Select.Option value="1week">One Week</Select.Option>
                  <Select.Option value="thismonth">One Month</Select.Option>
                </Select>
              </Typography.Title>
              <div className="tinycolumn">
                <CircleLine
                  TooltipUnit={"Kg"}
                  unit={`Kg`}
                  Data={co2Saved}
                  color={"#DD243B"}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default Co2Emission;
